module.exports = __webpack_public_path__ + "static/img/c36.60abdef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c36.jpg
// module id = 278
// module chunks = 0 1 2 3 4 5 6 7 8 9